


export const formatNumberToUSD = (num?: number) => {
  if (typeof num === 'number' && !isNaN(num)) {
    let formattedNum = (Math.abs(num)).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    if (num < 0) {
      formattedNum = "(" + formattedNum + ")";
    }
    return formattedNum;
  } else { // input was not a number. invalid input. return formatted $0.00.
    return (0).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }
};


export const eighteenYearsAgo = (): Date => {
  const today = new Date();
  return new Date(today.setMonth(today.getMonth() - 12 * 18));
}

export const getOrdinalSuffix = (number: number) => {

  const lastDigit = number % 10;
  const lastTwoDigits = number % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return 'th';
  if (lastDigit === 1) return 'st';
  if (lastDigit === 2) return 'nd';
  if (lastDigit === 3) return 'rd';
  return 'th';
}

